var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSkipIcon = function SvgSkipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D2329",
    fillRule: "evenodd",
    d: "M12 .75C5.787.75.75 5.787.75 12S5.787 23.25 12 23.25 23.25 18.213 23.25 12 18.213.75 12 .75M21.75 12a9.75 9.75 0 0 1-2.355 6.337L5.663 4.605A9.75 9.75 0 0 1 21.75 12m-19.5 0a9.75 9.75 0 0 1 2.355-6.337l13.732 13.732A9.75 9.75 0 0 1 2.25 12",
    clipRule: "evenodd"
  })));
};
export default SvgSkipIcon;